import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: ${({ active }) => (active ? 100 : 1)};
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9998;
  background: transparent;
`;

export const WrapperSelectOptions = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 100%;
  height: auto;
  top: ${props => !!props.topDistance && `calc(${props.topDistance}px + 8px)`};
  box-sizing: border-box;
  background: ${({ theme }) => theme.colors.semantic.surface.card};
  box-shadow: ${({ theme }) =>
    `${theme.colors.semantic.shadow.md}, ${theme.colors.semantic.shadow.md}`};
  border: 1px solid ${({ theme }) => theme.colors.semantic.border.default};
  border-radius: 8px;
  z-index: 9999;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: ${props => !!props.maxHeight && `calc(${props.maxHeight})`};
`;

export const ListItem = styled.button`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  outline: none;
  border: none;
  box-sizing: border-box;
  width: 100%;
  height: auto;
  color: ${({ theme }) => theme.colors.semantic.text.primary};
  padding: ${({ selectAllItem }) => (selectAllItem ? '16px' : '8px 16px')};
  gap: 8px;
  cursor: pointer;
  z-index: 0;

  background-color: ${({ theme, isSelectedOption }) =>
    isSelectedOption
      ? theme.colors.semantic.surface.muted
      : theme.colors.semantic.surface.card};

  &:hover {
    background-color: ${({ theme }) => theme.colors.semantic.surface.muted};
  }

  &:focus {
    outline: none;
    border: none;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      background-color: ${({ theme }) => theme.colors.semantic.surface.muted};
      color: ${({ theme }) => theme.colors.semantic.text.secondary};
      cursor: not-allowed;
      opacity: 0.7;
    `};

  transition: background-color 0.15s ease-in-out;
`;

export const Error = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.25px;
  color: ${({ theme }) => theme.colors.danger500};
`;

export const InputGroup = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  padding: 6px 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  overflow: hidden;
  min-height: 38px;
  height: auto;
  width: 100%;
  transition: border 0.1s ease-in;
  gap: 8px;
  border: 1px solid
    ${({ theme, error }) =>
      error ? theme.colors.danger500 : theme.colors.semantic.border.default};
  cursor: pointer;

  &:hover {
    border: 1px solid
      ${({ theme, active, disabled }) =>
        !active && !disabled && theme.colors.primary500};
  }

  ${({ theme, active }) =>
    active &&
    css`
      border: 1px solid ${theme.colors.primary500};
      svg {
        color: ${theme.colors.primary500};
        transition: color 0.2s ease-in;
      }

      button {
        border-left-color: ${theme.colors.primary500};
        transition: border-left-color 0.2s ease-in;
      }

      &:hover {
        border: 1px solid ${theme.colors.primary500};
      }
    `}

  ${({ theme, disabled }) =>
    disabled &&
    css`
      border: 1px solid ${theme.colors.semantic.border.default};
      background-color: ${theme.colors.semantic.surface.muted};
      color: ${theme.colors.semantic.text.secondary};
      cursor: not-allowed;
      opacity: 0.8;

      &:hover {
        border: 1px solid ${theme.colors.semantic.border.default};
      }
    `}
`;

export const WrapperMultiValues = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
  gap: 8px;
`;

export const Tag = styled.li`
  padding: 0 8px;
  border-radius: 8px;
  height: auto;
  background-color: ${({ theme }) => theme.colors.semantic.surface.selection};
  color: ${({ theme }) => theme.colors.primary500};
  border: 1px solid transparent;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;

  svg {
    color: ${({ theme }) => theme.colors.primary500};
    height: 14px;
    width: auto;
  }
  pointer-events: none;

  ${({ disabled }) =>
    disabled &&
    css`
      background-color: ${({ theme }) => theme.colors.semantic.surface.muted};
      color: ${({ theme }) => theme.colors.semantic.text.secondary};
      border-color: transparent;

      svg {
        color: ${({ theme }) => theme.colors.semantic.text.secondary};
      }
    `}
`;

export const TagValue = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  pointer-events: none;

  -webkit-user-select: none;
  user-select: none;
`;

export const Placeholder = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 1;

  color: ${({ theme }) => theme.colors.semantic.text.secondary};
`;
